import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

interface SummaryHeaderProps {
  hideOnMobile?: boolean;
}

const SummaryHeader = styled.div<SummaryHeaderProps>`
  @media (max-width: 767px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'block')};
  }
`;

interface HeaderProps {
  tourNameTranslation: string;
  guideFullName: string;
  tourId?: string | null;
  isInvoice?: boolean;
  hasResource?: boolean;
  resourceName?: string;
}

export const Header = ({
  tourNameTranslation,
  guideFullName,
  tourId = '',
  isInvoice = false,
  hasResource = false,
  resourceName,
}: HeaderProps) => {
  const headerCSSClass = classnames(
    'CheckoutSummary-ContentBox Summary-Header',
    {
      invoice: isInvoice,
    }
  );

  return (
    <SummaryHeader hideOnMobile className={headerCSSClass}>
      <h3 className="TourTitle item-title">
        <div>{tourNameTranslation}</div>
      </h3>
      <p className="GuideName item-subtitle">
        <FormattedMessage
          defaultMessage="with {guideName}"
          description="Guide name"
          values={{
            guideName: hasResource ? resourceName : guideFullName,
          }}
        />
      </p>
      {isInvoice && (
        <h4 className="InvoiceId item-subtitle">
          <FormattedMessage
            defaultMessage="Invoice #{tourId}"
            description="Invoice #"
            values={{ tourId }}
          />
        </h4>
      )}
    </SummaryHeader>
  );
};
